import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { PrismicReusableContentDataBodyInstantQuote } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { clsx } from "clsx";
import { graphql } from "gatsby";
import qs from "qs";
import { LoadingPanelInstantQuoteHero } from "../upload-file-panel/upload-file-panel.styled";
import UploadFilePanel, {
  IUploadFilePanelProps,
} from "../upload-file-panel/upload-file-panel";
import GeoMessage from "../geo-message/geo-message";
import CustomerQuoteRequest from "../customer-quote-request/customer-quote-request";

export const query = graphql`
  fragment InstantQuoteModule on PrismicReusableContentDataBody {
    ... on PrismicReusableContentDataBodyInstantQuote {
      slice_type
      primary {
        css_class
        heading {
          richText
          text
        }
        description {
          richText
          text
        }
        cta_text
        cta_link {
          url
          target
        }
        rfq_type
        show_instant_quote_button
        show_patent_notice
        show_secure_blurb
        show_supported_file_types
      }
    }
  }
`;

export type IInstantQuoteProps = {
  slice: PrismicReusableContentDataBodyInstantQuote;
};

const InstantQuote = (props: IInstantQuoteProps) => {
  console.log("InstantQuote");
  const { slice } = props;
  const { primary } = slice;

  // BEGIN: Instant Quote File Upload configs
  const queryParams = primary?.cta_link?.url
    ? primary?.cta_link.url.split("?")[1]
    : null;

  const parsedParams = queryParams ? qs.parse(queryParams) : { process: "" };
  const queryProcess = Object.prototype.hasOwnProperty.call(
    parsedParams,
    "process"
  )
    ? parsedParams.process
    : "";
  const uploadComponentContents = (
    <div className="!grid grid-flow-rows gap-2 text-center">
      {primary.heading && (
        <header>
          <PrismicRichText
            field={primary.heading.richText}
            components={htmlSerializer}
          />
        </header>
      )}
      {primary.description && (
        <PrismicRichText
          field={primary.description.richText}
          components={htmlSerializer}
        />
      )}
    </div>
  );
  const ctaText = "Start Your New Instant Quote";
  const ctaButton = ctaText && primary?.cta_text;
  const LoadingSkeletonCard = () => <LoadingPanelInstantQuoteHero />;
  const uploadProps = {
    panelStyle: "graySolid",
    processInitialism: queryProcess,
    segmentTrackPageSection: "instant-quote-hero",
    children: uploadComponentContents,
    showSupportedFileTypes: primary?.show_supported_file_types,
    showInstantQuoteButton: primary?.show_instant_quote_button,
    instantQuoteButtonContent: ctaButton,
    layoutDirection: "vertical",
    showSecureBlurb: primary?.show_secure_blurb,
    showPatentNotice: primary?.show_patent_notice,
    panelScale: "large",
    Fallback: LoadingSkeletonCard,
  } as IUploadFilePanelProps;
  // END: Instant Quote File Upload configs

  return (
    <div className={clsx([primary?.css_class])}>
      <GeoMessage />
      {primary?.rfq_type === "RFQ Only" ? (
        <CustomerQuoteRequest
          buttonText={primary?.cta_text || "Talk To An Expert"}
          standAlone={true}
          rfqTitle={primary?.heading.richText}
          compact
        />
      ) : (
        <UploadFilePanel {...uploadProps} />
      )}
    </div>
  );
};

export default InstantQuote;
